var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.activities),function(activity,index){
var _obj;
return _c('Card',{key:activity,class:( _obj = {
      sat: index === _vm.highlight,
      desat: _vm.highlight != null && index !== _vm.highlight}, _obj[activity] = true, _obj )},[_vm._v(_vm._s(_vm.capitalize(activity)))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }